import { CustomerLayout } from "@/components/CustomerLayout/CustomerLayout";
import { DocumentHjemmelserklaering } from "@/components/DocumentHjemmelserklaering/DocumentHjemmelserklaering";
import { routeLoaderApiClient } from "@/lib/api";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated-user/oppdrag/$tluxCaseId/opprett-hjemmelserklæring/")({
  loader: async ({ params }) => {
    const { tluxCaseId } = params;

    const res = await routeLoaderApiClient.oppdrag[":tluxCaseId"].hjemmelserklæring.defaults.$get({
      param: {
        tluxCaseId,
      },
    });

    if (res.ok === false) {
      throw new Error("Failed to fetch hjemmelserklæring defaults");
    }

    return {
      hjemmelserklæring: await res.json(),
    };
  },
  head: () => {
    return {
      meta: [{ title: "Opprett hjemmelserklæring | Alice & Bob" }],
    };
  },
  component: Page,
});

function Page() {
  const { tluxCaseId } = Route.useParams();
  const { hjemmelserklæring } = Route.useLoaderData();

  return (
    <CustomerLayout>
      <DocumentHjemmelserklaering
        tluxCaseId={tluxCaseId}
        hjemmelserklæring={hjemmelserklæring}
        cancelUrl={`/oppdrag/${tluxCaseId}`}
      />
    </CustomerLayout>
  );
}
